/*
Item: Reusable part of the editable forms containing the fields
This file contains no functionality - functionality is in UserData file
Name: DataForm
Format: Frontend component, partial screen
*/
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Card } from 'primereact/card';
import { Checkbox } from 'primereact/checkbox';
import { Panel } from 'primereact/panel';
import { formTypes } from '../utils/userFormTypes';
import { StatisticsAccessArray } from '../utils/statisticsUtils';
import { lockStates } from '../utils/lockStates';
import {
  RoleArray, hasPermission, actions, returnUserRights,
} from '../utils/roleUtils';

// Important: This class should only contain components.
// All functionality is organized in UserDataFile
export default class DataForm extends Component {
  // renders the footer for the save dialog
  saveFooter() {
    const { handleSaveYes, handleSaveNo } = this.props;
    return (
      <div>
        <Button
          label="Ja"
          id="yes"
          type="button"
          icon="pi pi-check"
          onClick={handleSaveYes}
        />
        <Button
          label="Nein"
          id="no"
          type="button"
          icon="pi pi-times"
          onClick={handleSaveNo}
          className="p-button-danger"
        />
      </div>
    );
  }

  // renders the footer for the abort-dialog
  abortFooter() {
    const { handleAbortNo, handleAbortYes } = this.props;
    return (
      <div>
        <Button
          label="Ja"
          id="yes"
          type="button"
          icon="pi pi-check"
          onClick={() => { handleAbortYes(); }}
        />
        <Button
          label="Nein"
          id="no"
          type="button"
          icon="pi pi-times"
          onClick={() => { handleAbortNo(); }}
          className="p-button-secondary"
        />
      </div>
    );
  }

  checkDisabled() {
    const { formType, role } = this.props;
    const disableValue = ((role !== 'INTERNAL_USER' && role !== '') || formType === formTypes.userEditsItself);
    return disableValue;
  }

  // renders the Card where all personal user data like role, name, email etc. are placed
  renderUserDataCard() {
    const {
      children, formType, formTitle, username, role,
      lastName, firstName, phone, fax,
      institution2, institution, street, houseNumber, zipcode, city, email,
      handleKeyDown, handleChange,
    } = this.props;
    return (
      <Card title={formTitle} style={{ height: '100%' }}>
        <div className="p-grid form-group">
          <div className="p-col-12">{children || ''}</div>

          {formType !== formTypes.userEditsItself
            && formType !== formTypes.adminCreatesNewUser
            && formType !== formTypes.userEditsItself ? (
              <div
                className={
                  `p-col-12 ${formType === formTypes.editAdminForm
                    || formType === formTypes.adminEditsUser
                    ? 'p-md-6'
                    : 'p-md-12'}`
                }
              >
                <span className="md-inputfield">
                  <InputText
                    id="username"
                    name="username"
                    disabled={
                      formType === formTypes.editAdminForm
                      || formType === formTypes.adminEditsUser
                      || formType === formTypes.adminCreatesNewUser
                      || formType === formTypes.userEditsItself
                    }
                    value={username || ''}
                    maxLength="12"
                    onChange={(e) => handleChange(e)}
                    onKeyDown={(e) => handleKeyDown(e)}
                    tooltip="Geben Sie hier den Benutzernamen ein."
                    tooltipOptions={{ event: 'focus' }}
                  />
                  <label htmlFor="username">Benutzername*</label>
                </span>
              </div>
            ) : (
              ''
            )}
          {formType === formTypes.editAdminForm
            || formType === formTypes.adminCreatesNewUser
            || formType === formTypes.userEditsItself
            || formType === formTypes.adminEditsUser ? (
              <div className="p-col-12 p-md-6">
                <Dropdown
                  disabled={
                    formType === formTypes.userEditsItself
                  }
                  placeholder="Benutzerrolle auswählen*"
                  name="role"
                  options={RoleArray}
                  value={role || ''}
                  onChange={(e) => handleChange(e)}
                  autoWidth={false}
                  tooltipOptions={{ event: 'focus' }}
                  autoFocus={
                    formType === formTypes.editAdminForm
                    || formType === formTypes.adminEditsUser
                    || formType === formTypes.adminCreatesNewUser
                    || formType === formTypes.userEditsItself
                  }
                />
              </div>
            ) : (
              ''
            )}

          {formType === formTypes.adminCreatesNewUser
            || formType === formTypes.userEditsItself ? (
              <div className="p-col-12 p-md-6" />
            ) : (
              ''
            )}

          <div className="p-col-12 p-md-6">
            <span className="md-inputfield">
              <InputText
                id="lastName"
                name="lastName"
                disabled={
                  formType === formTypes.editAdminForm
                }
                value={lastName || ''}
                maxLength="255"
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                autoFocus={
                  formType === formTypes.userEditsItself
                }
                tooltip="Geben Sie hier den Nachnamen ein."
                tooltipOptions={{ event: 'focus' }}
              />
              <label htmlFor="lastName">Nachname*</label>
            </span>
          </div>
          <div className="p-col-12 p-md-6">
            <span className="md-inputfield">
              <InputText
                id="firstName"
                name="firstName"
                disabled={
                  formType === formTypes.editAdminForm
                }
                value={firstName || ''}
                maxLength="255"
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                tooltip="Geben Sie hier den Vornamen ein."
                tooltipOptions={{ event: 'focus' }}
              />
              <label htmlFor="firstName">Vorname*</label>
            </span>
          </div>
          <div className="p-col-12 p-md-6">
            <span className="md-inputfield">
              <InputText
                id="phone"
                name="phone"
                value={phone || ''}
                maxLength="255"
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                tooltip="Geben Sie hier die Telefonnummer ein."
                tooltipOptions={{ event: 'focus' }}
              />
              <label htmlFor="phone">Telefon</label>
            </span>
          </div>
          <div className="p-col-12 p-md-6">
            <span className="md-inputfield">
              <InputText
                id="fax"
                name="fax"
                disabled={
                  formType === formTypes.editAdminForm
                }
                value={fax || ''}
                maxLength="255"
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                tooltip="Geben Sie hier die Faxfonnummer ein."
                tooltipOptions={{ event: 'focus' }}
              />
              <label htmlFor="fax">Fax</label>
            </span>
          </div>
          <div className="p-col-12 p-md-12">
            <span className="md-inputfield">
              <InputText
                id="email"
                name="email"
                value={email || ''}
                maxLength="255"
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                tooltip="Geben Sie hier die E-Mail-Adresse ein."
                tooltipOptions={{ event: 'focus' }}
                keyfilter="email"
              />
              <label htmlFor="email">E-Mail*</label>
            </span>
          </div>
          <div className="p-col-12 p-md-12">
            <span className="md-inputfield">
              <InputText
                id="institution"
                name="institution"
                value={institution || ''}
                maxLength="255"
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                tooltip="Geben Sie hier den Namen der Institution ein."
                tooltipOptions={{ event: 'focus' }}
              />
              <label htmlFor="institution">Institution*</label>
            </span>
          </div>
          <div className="p-col-12 p-md-12">
            <span className="md-inputfield">
              <InputText
                id="institution2"
                name="institution2"
                value={institution2 || ''}
                maxLength="255"
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                tooltip="Geben Sie hier weitere Angaben zur Institution ein."
                tooltipOptions={{ event: 'focus' }}
              />
              <label htmlFor="institution2">Institution (ggf. weitere Angaben)</label>
            </span>
          </div>
          <div className="p-col-12 p-md-9">
            <span className="md-inputfield">
              <InputText
                id="street"
                name="street"
                disabled={
                  formType === formTypes.editAdminForm
                }
                maxLength="255"
                value={street || ''}
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                tooltip="Geben Sie hier die Straße der Institution ein."
                tooltipOptions={{ event: 'focus' }}
              />
              <label htmlFor="street">Straße</label>
            </span>
          </div>
          <div className="p-col-12 p-md-3">
            <span className="md-inputfield">
              <InputText
                id="houseNumber"
                name="houseNumber"
                disabled={
                  formType === formTypes.editAdminForm
                }
                maxLength="10"
                value={houseNumber || ''}
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                tooltip="Geben Sie hier die Hausnummer der Institution ein."
                tooltipOptions={{ event: 'focus' }}
              />
              <label htmlFor="houseNumber">Hausnummer</label>
            </span>
          </div>
          <div className="p-col-12 p-md-3">
            <span className="md-inputfield">
              <InputText
                id="zipcode"
                name="zipcode"
                disabled={
                  formType === formTypes.editAdminForm
                }
                maxLength="10"
                value={zipcode || ''}
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                tooltip="Geben Sie hier die Postleitzahl der Institution ein."
                tooltipOptions={{ event: 'focus' }}
              />
              <label htmlFor="zipcode">PLZ</label>
            </span>
          </div>
          <div className="p-col-12 p-md-9">
            <span className="md-inputfield">
              <InputText
                id="city"
                name="city"
                disabled={
                  formType === formTypes.editAdminForm
                }
                value={city || ''}
                maxLength="255"
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                tooltip="Geben Sie hier den Ort der Institution ein."
                tooltipOptions={{ event: 'focus' }}
              />
              <label htmlFor="city">Ort</label>
            </span>
          </div>
        </div>
      </Card>
    );
  }

  // render the Card where all infomation belonging to access are placed
  renderRightsCard() {
    const userRights = returnUserRights();
    const canResetPassword = hasPermission(userRights, actions.UserCreate);
    const {
      role, lockState, accesses, handleSelectAll, formType, onAccessChange,
      handleDeselectAll, toggleNewPassword, generateNewPassword, toggleLock,
      // username,
    } = this.props;
    const lockButtonActive = (
      lockState === lockStates.open
      || lockState === lockStates.willChangeToOpen);
    return (
      <Card title="Zugriffsrechte" style={{ height: '100%' }}>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-12">
            <p style={{ fontSize: '12px', color: '#607D8B' }}>
              Zugriff auf die Hochschulstatistiken
            </p>
            <div className="p-grid p-fluid">
              {formType !== formTypes.userEditsItself
                ? (
                  <div className="p-col-12 p-md-6">
                    <Button
                      type="button"
                      id="all"
                      disabled={accesses.length === StatisticsAccessArray.length}
                      label="Alle auswählen"
                      onClick={() => handleSelectAll()}
                    />
                  </div>
                )
                : ''}
              {formType !== formTypes.userEditsItself
                ? (
                  <div className="p-col-12 p-md-6">
                    <Button
                      id="lock"
                      type="button"
                      disabled={!accesses.length || (role !== 'INTERNAL_USER' && role !== '')}
                      label="Alle abwählen"
                      onClick={() => handleDeselectAll()}
                    />
                  </div>
                )
                : ''}
            </div>
            <div className="p-grid" style={{ width: '250px' }}>
              <div className="p-col-12">
                <Checkbox disabled={this.checkDisabled()} inputId="cb1" value="21311_Studenten" onChange={onAccessChange} checked={accesses.indexOf('21311_Studenten') !== -1} />
                <label htmlFor="cb1" style={{ fontSize: '12px', color: '#607D8B' }} className="p-checkbox-label">Studierende</label>
              </div>
              <div className="p-col-12">
                <Checkbox disabled={this.checkDisabled()} inputId="cb2" value="21321_Prüfungen" onChange={onAccessChange} checked={accesses.indexOf('21321_Prüfungen') !== -1} />
                <label htmlFor="cb2" style={{ fontSize: '12px', color: '#607D8B' }} className="p-checkbox-label">Prüfungen</label>
              </div>
              <div className="p-col-12">
                <Checkbox disabled={this.checkDisabled()} inputId="cb3" value="21352_Promovierende" onChange={onAccessChange} checked={accesses.indexOf('21352_Promovierende') !== -1} />
                <label htmlFor="cb3" style={{ fontSize: '12px', color: '#607D8B' }} className="p-checkbox-label">Promovierende</label>
              </div>
              <div className="p-col-12">
                <Checkbox disabled={this.checkDisabled()} inputId="cb4" value="21351_Habilitationen" onChange={onAccessChange} checked={accesses.indexOf('21351_Habilitationen') !== -1} />
                <label htmlFor="cb4" style={{ fontSize: '12px', color: '#607D8B' }} className="p-checkbox-label">Habilitationen</label>
              </div>
              <div className="p-col-12">
                <Checkbox disabled={this.checkDisabled()} inputId="cb5" value="21341_Hochschulperso" onChange={onAccessChange} checked={accesses.indexOf('21341_Hochschulperso') !== -1} />
                <label htmlFor="cb5" style={{ fontSize: '12px', color: '#607D8B' }} className="p-checkbox-label">Hochschulpersonal</label>
              </div>
              <div className="p-col-12">
                <Checkbox disabled={this.checkDisabled()} inputId="cb6" value="21371_Finanzen" onChange={onAccessChange} checked={accesses.indexOf('21371_Finanzen') !== -1} />
                <label htmlFor="cb6" style={{ fontSize: '12px', color: '#607D8B' }} className="p-checkbox-label">Hochschulfinanzen</label>
              </div>
            </div>
          </div>
          {formType !== formTypes.adminCreatesNewUser
            && formType !== formTypes.userEditsItself
            ? (
              <div className="p-col-12 p-md-6">
                <p style={{ fontSize: '12px', color: '#607D8B', marginTop: '5px' }}>
                  Benutzerstatus:
                  {(lockState === lockStates.open || lockState === lockStates.willChangeToOpen)
                    ? (
                      <span>
                        <i
                          className="pi-md-lock-open"
                          style={{ position: 'relative', top: '4px' }}
                        />
                        {(lockState === lockStates.open) ? ' entsperrt' : ' Zum Entsperren vorgemerkt. Bitte speichern Sie, um den Anwender zu entsperren.'}
                      </span>
                    )
                    : (
                      <span>
                        <i
                          className="pi-md-lock-outline"
                          style={{ position: 'relative', top: '4px' }}
                        />
                        {(lockState === lockStates.locked) ? ' gesperrt' : ' Zum Sperren vorgemerkt. Bitte speichern Sie, um den Anwender zu sperren.'}
                      </span>
                    )}
                </p>
                {' '}
                <div className="p-grid p-fluid">
                  <div className="p-col-12 p-md-6">
                    <Button
                      type="button"
                      id="unlock"
                      className={lockButtonActive ? 'p-button-success' : ''}
                      style={!lockButtonActive ? { pointerEvents: 'auto' } : { pointerEvents: 'none' }}
                      disabled={lockButtonActive}
                      label="Entsperren"
                      onClick={() => toggleLock()}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <Button
                      id="lock"
                      className={!lockButtonActive ? 'p-button-danger' : ''}
                      style={lockButtonActive ? { pointerEvents: 'auto' } : { pointerEvents: 'none' }}
                      type="button"
                      disabled={!lockButtonActive}
                      label="Sperren"
                      onClick={() => toggleLock()}
                    />
                  </div>
                </div>
                <p style={{ fontSize: '12px', color: '#607D8B' }}>
                  Kennwort
                </p>
                <div className="p-col-12 p-md-12">
                  {(canResetPassword && formType === formTypes.adminEditsUser)
                    ? (
                      <div>
                        <Checkbox
                          value="password"
                          inputId="cbPass"
                          onChange={() => { toggleNewPassword(); }}
                          checked={generateNewPassword}
                        />
                        <label
                          htmlFor="cbPass"
                          style={{ fontSize: '12px', color: '#607D8B' }}
                          className="p-checkbox-label"
                        >
                          Neues Kennwort generieren
                        </label>
                      </div>
                    )
                    : 'Änderungen an Ihrem Kennwort können Sie über den Menüpunkt "Kennwort ändern" durchführen.'}

                  {generateNewPassword
                    ? (
                      <p style={{ fontSize: '12px', color: '#607D8B' }}>
                        Bitte Speichern Sie, um dem Anwender ein neues Kennwort zuzusenden.
                      </p>
                    )
                    : ' '}
                </div>
              </div>
            )
            : ' '}
        </div>
      </Card>
    );
  }

  // renders the Card where bottons to save or abort are placed
  renderSubmitAbortCard() {
    const { validateForm, openAbortDialog, openSaveDialog } = this.props;
    return (
      <Card>
        <Button
          type="submit"
          id="save"
          className={validateForm() ? 'p-button-success' : 'p-button-primary'}
          label="Speichern"
          icon="pi-md-check"
          disabled={!validateForm()}
          tooltip={
            validateForm()
              ? 'Klick oder Enter'
              : 'Bitte füllen Sie alle mit * gekennzeichneten Pflichtfelder aus'
          }
          tooltipOptions={{ position: 'bottom' }}
          onClick={openSaveDialog}
        />
        <Button
          icon="pi-md-cancel"
          id="cancel"
          type="button"
          label="Abbrechen"
          onClick={openAbortDialog}
        />
      </Card>
    );
  }

  renderProgressDialog() {
    const { progressDialogVisible } = this.props;
    return (
      <Dialog
        header="Aktualisiere Ansicht..."
        closable={false}
        closeOnEscape={false}
        visible={progressDialogVisible}
        onHide={() => { }}
        modal
      >
        <div style={{ textAlign: 'center' }}>
          <ProgressSpinner />
        </div>
      </Dialog>
    );
  }

  renderSaveDialog() {
    const { handleSaveNo, saveDialogVisible } = this.props;
    return (
      <Dialog
        header="Daten speichern"
        visible={saveDialogVisible}
        style={{ width: '40vw' }}
        footer={this.saveFooter()}
        onHide={handleSaveNo}
        modal
      >
        <p>Sind Sie sich sicher, dass Sie die Daten speichern wollen?</p>
      </Dialog>
    );
  }

  renderAbortDialog() {
    const { abortDialogVisible, handleAbortNo } = this.props;
    return (
      <Dialog
        header="Abbruch"
        visible={abortDialogVisible}
        style={{ width: '40vw' }}
        footer={this.abortFooter()}
        onHide={handleAbortNo}
        modal
      >
        <p>
          Sind Sie sich sicher, dass Sie die Bearbeitung abbrechen wollen?
          Ihre getätigten Eingaben werden nicht übernommen.
        </p>
      </Dialog>
    );
  }

  render() {
    const { username, formType, openSaveDialog } = this.props;
    return (
      <form ref={this.form} onSubmit={() => { openSaveDialog(); }}>
        <div className="p-grid p-fluid">
          {username === sessionStorage.getItem('username') && formType === formTypes.adminEditsUser
            ? (
              <div className="p-col-12 p-lg-12">
                <div>
                  <Panel style={{ backgroundColor: '#F44336', color: 'white' }}>
                    Hinweis: Sie bearbeiten Ihre eigenen Daten.
                    Änderungen an Ihren Zugriffsrechten können den
                    Umfang Ihrer Administatorenrechte einschränken.
                  </Panel>
                </div>
              </div>
            )
            : ''}
          <div className="p-col-12 p-lg-6">
            {this.renderUserDataCard()}
          </div>

          <div className="p-col-12 p-lg-6">
            {this.renderRightsCard()}
          </div>
        </div>
        {this.renderSubmitAbortCard()}
        {this.renderProgressDialog()}
        {this.renderSaveDialog()}
        {this.renderAbortDialog()}
      </form>
    );
  }
}

DataForm.propTypes = {
  formType: PropTypes.string.isRequired,
  formTitle: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  fax: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  institution: PropTypes.string.isRequired,
  institution2: PropTypes.string.isRequired,
  street: PropTypes.string.isRequired,
  houseNumber: PropTypes.string.isRequired,
  zipcode: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  progressDialogVisible: PropTypes.string.isRequired,
  saveDialogVisible: PropTypes.string.isRequired,
  abortDialogVisible: PropTypes.string.isRequired,
  accesses: PropTypes.string.isRequired,
  generateNewPassword: PropTypes.string.isRequired,
  lockState: PropTypes.string.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  validateForm: PropTypes.func.isRequired,
  openAbortDialog: PropTypes.func.isRequired,
  handleAbortYes: PropTypes.func.isRequired,
  handleAbortNo: PropTypes.func.isRequired,
  openSaveDialog: PropTypes.func.isRequired,
  handleSaveYes: PropTypes.func.isRequired,
  handleSaveNo: PropTypes.func.isRequired,
  toggleNewPassword: PropTypes.func.isRequired,
  toggleLock: PropTypes.func.isRequired,
  handleSelectAll: PropTypes.func.isRequired,
  handleDeselectAll: PropTypes.func.isRequired,
  onAccessChange: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};
